import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<summary class=\"menuTrigger\" ...attributes data-test-menu-summary>\n  <div>\n    {{yield}}\n  </div>\n</summary>")